export const DEFAULT_PROFILE_IMAGE =
  'https://storage.googleapis.com/user-avatars-prod/22_1613650519914_92761644.png';

export const getIsDefaultProfileImage = (imageLink) => {
  return imageLink === DEFAULT_PROFILE_IMAGE;
};
